import React from 'react'
import ReactDom from 'react-dom'
import coact from 'coact'

import models from './models'
import views from './views'

import GateRecordImporter from './components/GateRecordImporter'
import OvertimeRecordImporter from './components/OvertimeRecordImporter'
import AttendanceChecker from './components/AttendanceChecker'
import UploadTemplate from './components/UploadTemplate'
import LeavesReporter from './components/LeavesReporter'


/*
const names = [
  'users',
  'gateRecords',
  'leaveRecords',
  'attendanceRecords',

  'staffers',
]

const models = load({ dir: 'models', names })
const views = load({ dir: 'views', names })
*/


const config = {
  models,
  views,
  ui: {
    navbar: {
      title: '技聯組',
    },
  },
  routes: [
    { component: GateRecordImporter, path: '/import/gateRecords' },
    { component: OvertimeRecordImporter, path: '/import/overtimeRecords' },
    { component: AttendanceChecker, path: '/check/attendanceRecords' },
    { component: UploadTemplate, path: '/upload/template' },
    { component: LeavesReporter, path: '/print/leaves' },
  ],
}

const App = coact(config)

window.React = React
ReactDom.render(
  React.createElement(App),
  document.getElementById(config.mountDomId || 'app'),
)



// WEBPACK FOOTER //
// ./src/client.js